import {find} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, IconName} from 'components';
import {AgentParticipant} from 'interfaces';
import {SessionNote, SessionNoteAccess} from 'types';
import {sessionUtils} from 'utils';

type Props = {
    note: SessionNote;
    localUserEid: number;
    participants: AgentParticipant[];
}

export const SessionHistoryNoteItem: React.FC<Props> = ({note, participants, localUserEid}) => {
    const {t} = useTranslation();

    const author = useMemo(() => find(participants, (p) => p.data.eid === note.authorEid), [note, participants]);
    const isMe = useMemo(() => note.authorEid === localUserEid, [note, localUserEid]);

    const authorName = useMemo(() => author ?
        sessionUtils.getParticipantNameWithMe(t, author.data, isMe) :
        note.authorEid,
    [t, author, note, isMe]);

    const iconName: IconName = useMemo(() => {
        if (isMe) {
            if (note.access === SessionNoteAccess.Public) {
                return 'eye';
            } else if (note.access === SessionNoteAccess.Private) {
                return 'eye-off';
            } else {
                return null;
            }
        }

        return 'agent-participant';
    }, [isMe, note]);

    return (
        <div className='tw-mb-2 tw-border tw-border-default tw-p-4 tw-rounded-lg'>
            <div className='tw-break-words'>{note.message}</div>
            <div className='tw-text-default-dimmed tw-mt-2 tw-flex tw-items-center'>
                {iconName && <Icon name={iconName} className='tw-mr-2' />}
                {authorName}
            </div>
        </div>
    );
};